<template>
	<v-dialog
		v-model="dialog"
		max-width="fit-content"
		scrollable>

		<div v-shortkey="['esc']" @shortkey="dialog = false"></div>

		<template v-slot:activator="{ on }">
			<v-btn
				flat small
				color="blue lighten-1"
				class="text-none my-0 mx-1 activator-btn"
				v-on="on">
				<slot>
					<v-icon class="mr-1">tag</v-icon>
					Suifa OF
				</slot>
			</v-btn>
		</template>

		<v-card class="background darken-1">
			<v-card-title class="py-1">
				<span class="headline">
					Suifa OF
				</span>
				<v-spacer></v-spacer>
				<v-btn
					icon small
					@click="dialog = false"
					class="mr-3">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pa-2">
				<SuifaOF @assets-selected="
					$emit('suifa-asset-selected', $event);
					dialog = false
				">
				</SuifaOF>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import SuifaOF from '@/pages/tools/suifa_of/suifa_of.vue'
export default {
	components: {
		SuifaOF
	},
	data () {
		return {
			dialog: false
		}
	}
}
</script>

<style lang="stylus" scoped>
.v-card
	border-radius: 4px
.v-card__title
	border-top: 1px solid var(--v-background-lighten2)
	border-left: 1px solid var(--v-background-lighten2)
	border-right: 1px solid var(--v-background-lighten2)
.v-card__text
	border-bottom: 1px solid var(--v-background-lighten2)
	border-left: 1px solid var(--v-background-lighten2)
	border-right: 1px solid var(--v-background-lighten2)
</style>



// WEBPACK FOOTER //
// src/pages/tools/suifa_of/suifa_of_dialog.vue